<template>
  <div v-if="!selecionouExportacao">
    <div class="exportacao-content" v-for="subimposto in imposto.dados">
      <RadioButton
        v-if="dadosExportacao.length > 1 && subimposto.desabilita != 1 && !subimposto.alerta"
        :seleciona="seleciona"
        :imposto="subimposto"
        :classe="classe"
      />

      <Registro :paddingSemCheckBox="dadosExportacao.length <= 1">
        <Cabecalho :titulo="subimposto.label" :aliquota="subimposto.aliquota" />

        <Notificacao v-if="subimposto.alerta" :tipo="'alerta'" :texto="subimposto.alerta" />
        <GrupoNotificacao :registro="subimposto" />

        <div class="separador" :dado="subimposto" />

        <Ncm :ncm="subimposto.ncm" />
        <div class="separador" v-if="subimposto.ncm" :dado="subimposto" />

        <Descricao :titulo="'Descrição'" :descricao="subimposto.descricao" />
        <div class="separador" v-if="subimposto.descricao" :dado="subimposto" />

        <BaseLegal :base_legal="subimposto.base_legal" :classe="imposto.classe" />
      </Registro>
    </div>
  </div>

  <div v-else>
    <div class="exportacao-content">
      <EditButton v-if="dadosExportacao.length > 1" :edita="edita" :classe="classe" />
      <div class="exportacao-registro-container">
        <Registro :paddingSemCheckBox="dadosExportacao.length <= 1">
          <Cabecalho :titulo="registroSelecionado.label" :aliquota="registroSelecionado.aliquota" />

          <Notificacao
            v-if="registroSelecionado.alerta"
            :tipo="'alerta'"
            :texto="registroSelecionado.alerta"
          />
          <GrupoNotificacao :registro="registroSelecionado" />

          <div class="separador" :dado="registroSelecionado" />

          <Ncm :ncm="registroSelecionado.ncm" />
          <div class="separador" v-if="registroSelecionado.ncm" :dado="registroSelecionado" />

          <Descricao :titulo="'Descrição'" :descricao="registroSelecionado.descricao" />
          <div class="separador" v-if="registroSelecionado.descricao" :dado="registroSelecionado" />

          <BaseLegal :base_legal="registroSelecionado.base_legal" :classe="imposto.classe" />
        </Registro>
      </div>
    </div>
  </div>
</template>

<script>
import AcordoComercial from "@/components/AcordoComercial/AcordoComercial.vue";
import BaseLegal from "@/components/BaseLegal/BaseLegal.vue";
import Cabecalho from "@/components/Cabecalho/Cabecalho.vue";
import Descricao from "@/components/Descricao/Descricao.vue";
import EditButton from "@/components/Button/EditButton.vue";
import Ncm from "@/components/Ncm/Ncm.vue";
import Notificacao from "@/components/Notificacao/Notificacao.vue";
import RadioButton from "@/components/Button/RadioButton.vue";
import Registro from "@/components/Registro/Registro.vue";
import GrupoNotificacao from "@/components/GrupoNotificacao/GrupoNotificacao.vue";
import QuadroAlertaZfm from "@/components/QuadroAlertaZfm/QuadroAlertaZfm.vue";

export default {
  name: "RegistrosExportacao",

  props: {
    imposto: Array | Object,
    classe: String,
    seleciona: Function,
    edita: Function,
    registroSelecionado: Object,
    selecionouExportacao: Boolean
  },

  components: {
    AcordoComercial,
    BaseLegal,
    Cabecalho,
    Descricao,
    EditButton,
    Ncm,
    GrupoNotificacao,
    Notificacao,
    RadioButton,
    Registro,
    QuadroAlertaZfm
  },

  data() {
    return {};
  },

  created() {
    if (this.imposto && this.dadosExportacao.length == 1) {
      this.seleciona(this.dadosExportacao[0]);
    }
  },

  mounted() {},

  computed: {
    dadosExportacao() {
      let dados = this.imposto.dados.filter(imposto => imposto.ordem != 101);
      return dados;
    },
    alertasFiltrados() {
      let dados = this.imposto.dados.filter(imposto => imposto.ordem == 101);
      return dados;
    }
  },

  methods: {}
};
</script>

<style lang="scss" scoped>
.exportacao-content {
  display: flex;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }
}
.cabecalho-acordo {
  margin-bottom: 1rem;
}
.aliquota-efetiva {
  margin-top: 0.8rem;
}
.exportacao-registro-container {
  width: 100%;
}
</style>
